export const getPreload = (): any => {
  const preload = document.querySelector("#preload");
  if (preload.textContent) {
    return JSON.parse(preload.textContent);
  }
  return {};
};
